import React from 'react';
import { upperFirstLetter } from 'utils/strings';
import TextField from 'shared/components/text-field/TextField';
import NutritionData from '../NutritionData';

const MealTitleForm = props => {
  const { meal, handleMealNameChange } = props;
  const type = upperFirstLetter(meal.type);

  return (
    <div className="form-content">
      <TextField
        type="text"
        name="name"
        label={`${type} Title`}
        placeholder={`${type} Name`}
        onChange={handleMealNameChange}
      />
      <NutritionData
        protein={meal.ingredients_protein}
        carbs={meal.ingredients_carbs}
        fat={meal.ingredients_fat}
        calories={meal.ingredients_calories}
      />
    </div>
  );
};

export default MealTitleForm;
